import bindAllMethods from '../../../utils/bindAllMethods';
import { getServices } from '../../../infra/startup';
import { ILoggerService } from '../../../services/loggerService';
import {
  NewLoggerInterfaceType,
  ErrorLoggerType,
  DebugLoggerType,
  LogLoggerType,
  WarnLoggerType,
  SystemLoggerType
} from '@clientos/types';

class NewLoggerInterface {
  private _loggerService: ILoggerService;

  constructor() {
    const services = getServices();
    this._loggerService = services.loggerService;

    bindAllMethods(this);
  }

  getInterface(): NewLoggerInterfaceType {
    return {
      createLoggerInstance: this._loggerService.createLoggerInstance,
      setLocalOptions: this._loggerService.setLocalOptions,
      removeLocalOptions: this._loggerService.removeLocalOptions,
      log: this._loggerService.infoLogger as LogLoggerType,
      debug: this._loggerService.debugLogger as DebugLoggerType,
      warn: this._loggerService.warnLogger as WarnLoggerType,
      error: this._loggerService.errorLogger as ErrorLoggerType,
      system: this._loggerService.systemLogger as SystemLoggerType
    } as unknown as NewLoggerInterfaceType;
  }
}

export default NewLoggerInterface;
